
















































import store from '@/store/store'
import { Component, Vue } from 'vue-property-decorator'
import LogService from '../api/broadcast/LogService'
import SupportService from '../api/support/SupportService'
import device from 'vue-device-detector'
import downloadAppFunc from '@/shared/functions/downloadAppFunc'
import ButtonComponent from './buttons/ButtonComponent.vue'
import ToggleSwitchComponent from './switches/ToggleSwitchComponent.vue'

Vue.use(device)

@Component({
  components: {
    PageHeaderComponent: () => import('./PageHeaderComponent.vue'),
    ButtonComponent,
    ToggleSwitchComponent
  }
})

export default class SupportSheetComponent extends Vue {
  private allTopics: any
  private selectedTopic: any = ''
  public description = ''
  public attachScreenshot = true
  public screenShot: any = ''
  private title: any = ''
  public isAeroguestSupportCompleted: any = false
  private additionalInfo: any = null
  public invalid = false;
  public pressedSubmit = false;
  public isDesktop = false;

  async created () {
    await this.getSupportTopics()
    this.filterTheTopicRow()
    await this.getSupportData()
    this.isDesktop = downloadAppFunc.checkIfDesktop()
  }

  private async getSupportTopics () {
    try {
      this.allTopics = await SupportService.GetSupportTopics('Default')
    } catch (error) {
      console.log(error)
    }
  }

  private async getSupportData () {
    if (this.$route.params.imageScreenshot !== undefined && this.$route.params.title !== undefined) {
      this.screenShot = this.$route.params.imageScreenshot
    } else {
      const data = await store.getSupportData()
      this.screenShot = data.img
      this.attachScreenshot = data.enableImg
      this.title = data.title
    }
  }

  private async getAdditionalInformation () {
    const phoneNumber = store.getPhoneNumber()
    const countryCode = store.getCountryCode()
    let phone = ''

    if (phoneNumber !== null && countryCode !== null) {
      phone = countryCode + phoneNumber
    }

    const identifier = store.getIdentifier()

    if (identifier !== null) {
      this.additionalInfo = {
        Identifier: identifier?.Identifier,
        Token: identifier?.Token,
        PhoneNumber: phone
      }
    }
  }

  private filterTheTopicRow () {
    try {
      const index: any = this.allTopics.findIndex((o: any) => o.Topic === 'GeneralFeedback')
      const generalFeedback = this.allTopics.splice(index, 1)
      this.allTopics = [...generalFeedback, ...this.allTopics]
      this.selectedTopic = this.allTopics[0]
    } catch (error) {
      console.log(error)
    }
  }

  public handleScreenshot (showScreenshot: boolean) {
    this.attachScreenshot = showScreenshot
    store.saveSupportData({ img: this.screenShot, title: this.title, enableImg: this.attachScreenshot })
  }

  private getTitle (title: string) {
    switch (title) {
      case 'sign-up':
        return 'Landing page'
      case 'downloadapppage':
        return 'Download app'
      case 'countrycodesheet':
        return 'Country code sheet'
      case 'confirm-confirmation-code':
        return 'Verification code'
      default:
        return 'Other'
    }
  }

  public validateDescription () {
    const spacesRemoved = this.description.trim()
    if (spacesRemoved === '') {
      this.invalid = true
    } else {
      this.invalid = false
    }
  }

  public async submit () {
    this.pressedSubmit = true
    try {
      this.validateDescription()
      if (this.invalid) {
        return
      }
      this.getAdditionalInformation()
      const data = JSON.parse(JSON.stringify(this.selectedTopic))
      this.screenShot = this.attachScreenshot ? this.screenShot : ''
      const idAsBase64 = this.screenShot.split(',')
      const img = idAsBase64[1]
      await SupportService.PostBTCTicket(data.Topic, 'Join pages', this.getTitle(this.title), this.description, img, this.additionalInfo)
      store.removeLocalstorage('AGSUPPORTDATA')
      this.isAeroguestSupportCompleted = true
    } catch (error) {
      LogService.LogError('Failed to submit problem in AeroGuest Support', { SubmitSupportFailed: 1 })
    }
  }

  public async downloadApp () {
    await downloadAppFunc.checkOS()
  }
}
